import React from 'react';
import type { BillingSummaryProps } from '../types';

const BillingSummaryView: React.FC<BillingSummaryProps> = ({ summary }) => {
    const { totalCost, discount, effectiveServiceRate, serviceBill, gstBreakdown, grandTotal } = summary;

    return (
        <div className="posv2-cart__summary">
            <div className="posv2-cart__summary-row">
                <span>Subtotal</span>
                <span>₹{totalCost.toFixed(2)}</span>
            </div>

            {discount > 0 && (
                <div className="posv2-cart__summary-row posv2-cart__summary-row--discount">
                    <span>Discount</span>
                    <span>-₹{discount}</span>
                </div>
            )}

            {!!effectiveServiceRate && (
                <div className="posv2-cart__summary-row">
                    <span>Service ({effectiveServiceRate}%)</span>
                    <span>₹{serviceBill.toFixed(2)}</span>
                </div>
            )}

            {Object.entries(gstBreakdown.gstData).map(([rate, amount]) =>
                amount ? (
                    <div key={rate} className="posv2-cart__summary-row">
                        <span>GST ({rate}%)</span>
                        <span>₹{amount.toFixed(2)}</span>
                    </div>
                ) : null
            )}

            <div className="posv2-cart__summary-row posv2-cart__summary-row--total">
                <span>Total</span>
                <span>₹{grandTotal}</span>
            </div>
        </div>
    );
};

export default React.memo(BillingSummaryView);
